import React from 'react';
import Component from '@vfuk/core-skinny-banner';
const SkinnyBanner = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SkinnyBanner;
